"use client";

import { useRef } from "react";
import { motion, useInView } from "framer-motion";

interface SkillBarProps {
    name: string;
    level: number; // 0-100
    color?: string;
    icon?: string;
}

export function SkillBar({
    name,
    level,
    color,
    icon,
}: SkillBarProps) {
    const ref = useRef<HTMLDivElement>(null);
    const isInView = useInView(ref, { once: true, margin: "-40px" });

    // Fallback if color is not provided or empty
    const barGradient = color || "from-dev-blue to-dev-cyan";

    return (
        <div ref={ref} className="space-y-2">
            <div className="flex items-center justify-between">
                <span className="flex items-center gap-2 text-sm font-medium text-dev-text-primary">
                    {icon && <span className="text-base">{icon}</span>}
                    {name}
                </span>
                <span className="font-mono text-xs text-dev-text-muted">{level}%</span>
            </div>
            <div className="h-2 w-full overflow-hidden rounded-full bg-dev-bg-light/50">
                <motion.div
                    className={`h-full rounded-full bg-gradient-to-r ${barGradient}`}
                    initial={{ width: 0 }}
                    animate={isInView ? { width: `${level}%` } : { width: 0 }}
                    transition={{ duration: 1, ease: [0.2, 0, 0, 1], delay: 0.2 }}
                    style={{
                        boxShadow: isInView
                            ? "0 0 12px rgba(59, 130, 246, 0.4)"
                            : "none",
                    }}
                />
            </div>
        </div>
    );
}
